import React from 'react';
import { Box, Paper, Avatar, makeStyles } from '@material-ui/core';
import { Agent } from './types';
import { getAgentIcon } from './utils';

const useStyles = makeStyles(theme => ({
  typingContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(3),
    // animation: '$fadeIn 0.3s ease-out',
  },
  avatar: {
    width: 36,
    height: 36,
    marginRight: theme.spacing(1.5),
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)',
    border: `2px solid ${theme.palette.background.paper}`,
  },
  typingPaper: {
    padding: theme.spacing(2, 2.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: '20px 20px 20px 6px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: -6,
      width: 0,
      height: 0,
      borderRight: `6px solid ${theme.palette.background.paper}`,
      borderBottom: '6px solid transparent',
    },
  },
  typingPaperSts: {
    backgroundColor: '#ffffff !important',
    border: '1px solid #e0e0e0 !important',
    borderRadius: '4px 12px 12px 4px !important',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08) !important',
    '&::before': {
      display: 'none',
    },
  },
  typingDots: {
    display: 'flex',
    gap: theme.spacing(0.75),
    alignItems: 'center',
  },
  typingDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
    animation: '$typing 1.6s infinite ease-in-out',
  },
  '@keyframes typing': {
    '0%, 60%, 100%': {
      opacity: 0.3,
      transform: 'scale(0.8)',
    },
    '30%': {
      opacity: 1,
      transform: 'scale(1.2)',
    },
  },
}));

interface TypingIndicatorProps {
  isTyping: boolean;
  agentConfig: Agent;
  stsMode?: boolean;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  isTyping,
  agentConfig,
  stsMode = false,
}) => {
  const classes = useStyles();

  return (
    <>
      {isTyping && (
        <Box className={classes.typingContainer}>
          <Avatar
            className={classes.avatar}
            style={{ backgroundColor: agentConfig.color }}
          >
            {getAgentIcon(agentConfig.icon)}
          </Avatar>
          <Paper className={`${classes.typingPaper} ${stsMode ? classes.typingPaperSts : ''}`}>
            <Box className={classes.typingDots}>
              {[0, 1, 2].map(i => (
                <Box
                  key={i}
                  className={classes.typingDot}
                  style={{ animationDelay: `${i * 0.2}s` }}
                />
              ))}
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
};
